module.exports = __webpack_public_path__ + "media/bg.e44abd08.mp4";